import { Routes, Route, BrowserRouter, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { GestorPartidasNavProvider } from "./context/GestorPartidasNavContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import BudgetWizard from "./pages/BudgetWizard";
import Catalog from "./pages/Catalog";
import GestorPartidas from "./pages/GestorPartidas";
import AnnotationsAdmin from "./pages/AnnotationsAdmin";
import Login from "./pages/Login";
import AuthVerify from "./pages/AuthVerify";
import Onboarding from "./pages/Onboarding";
import Clientes from "./pages/Clientes";
import AnnotatorPanel from "./components/AnnotatorPanel";
import { useAnotadorKonamiShortcut } from "./lib/anotador";
import "./App.css";

function CargandoPantalla() {
  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">
      Cargando…
    </div>
  );
}

function RequireAuth({ children }) {
  const { isAuthenticated, cargando, onboardingCompleto } = useAuth();
  const location = useLocation();
  if (cargando) return <CargandoPantalla />;
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }
  if (!onboardingCompleto) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

function RequireAuthOnboarding({ children }) {
  const { isAuthenticated, cargando, onboardingCompleto } = useAuth();
  if (cargando) return <CargandoPantalla />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (onboardingCompleto) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { isAuthenticated, cargando, onboardingCompleto } = useAuth();
  if (cargando) return <CargandoPantalla />;
  if (isAuthenticated) {
    return <Navigate to={onboardingCompleto ? "/" : "/onboarding"} replace />;
  }
  return children;
}

function AnotadorShortcutListener() {
  useAnotadorKonamiShortcut();
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <GestorPartidasNavProvider>
          <AnotadorShortcutListener />
          <Routes>
            <Route
              path="/login"
              element={
                <PublicOnly>
                  <Login />
                </PublicOnly>
              }
            />
            <Route path="/auth/verify" element={<AuthVerify />} />
            <Route
              path="/onboarding"
              element={
                <RequireAuthOnboarding>
                  <Onboarding />
                </RequireAuthOnboarding>
              }
            />
            <Route
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/nuevo" element={<BudgetWizard />} />
              <Route path="/presupuesto/:id" element={<BudgetWizard />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/catalogo" element={<Catalog />} />
              <Route path="/gestor-partidas" element={<Navigate to="/gestor-partidas/rehabilitacion" replace />} />
              <Route path="/gestor-partidas/:tipo" element={<GestorPartidas />} />
              <Route path="/anotaciones" element={<AnnotationsAdmin />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
          <AnnotatorPanel />
        </GestorPartidasNavProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
